export const fetchProductData = async () => {
    try {
        const response = await fetch('/wp-content/uploads/luxxbox-acoustic-analyzer/data/data-products.json');
        if (!response.ok) {
            throw new Error('Failed to load products data');
        }
        const productData = await response.json();
        // $log.log(`productData : ${JSON.stringify(productData, null, 4)}`);
        return productData;
    } catch (error) {
        console.error(error);
        return null;
    }
};

export const fetchProductsDataExtended = async () => {
    try {
        const response = await fetch('/wp-content/uploads/luxxbox-acoustic-analyzer/data/data-products-extended.json');
        if (!response.ok) {
            throw new Error('Failed to load products extended data');
        }
        const productsDataExtended = await response.json();

        // Add NON-LIT options for products with acoustic_only_version: true
        const processedData = addNonLitOptions(productsDataExtended);

        return processedData;
    } catch (error) {
        console.error(error);
        return null;
    }
};

/*
------------------------------------------------------------------------
Add NON-LIT options to products with acoustic_only_version: true

For each product, groups entries by (size, variant) and adds a NON-LIT
entry if any item in the group has acoustic_only_version: true.

@param {Object} data - The products extended data object
@return {Object} Processed data with NON-LIT options added
------------------------------------------------------------------------
*/
const addNonLitOptions = (data) => {
    if (!data || typeof data !== 'object') return data;

    const result = {};

    for (const [productId, entries] of Object.entries(data)) {
        if (!Array.isArray(entries)) {
            result[productId] = entries;
            continue;
        }

        // Group entries by size + variant + shape
        // Shape is included so NON-LIT entries inherit the correct shape
        // for filtering in ProductSizeSelector (which matches on shape)
        const groups = {};
        entries.forEach((entry) => {
            const key = `${entry.size}|${entry.variant || ''}|${entry.shape || ''}`;
            if (!groups[key]) {
                groups[key] = [];
            }
            groups[key].push(entry);
        });

        // Start with original entries
        const processedEntries = [...entries];

        // For each group, add NON-LIT if any has acoustic_only_version: true
        for (const [key, groupEntries] of Object.entries(groups)) {
            const hasAcousticOnly = groupEntries.some((e) => e.acoustic_only_version === true);
            if (hasAcousticOnly) {
                const [size, variant, shape] = key.split('|');
                const nonLitEntry = {
                    size: size,
                    variant: variant,
                    output: 'NON-LIT',
                    lumen_total: 0,
                    lumen_d: 0,
                    lumen_i: 0,
                    isNonLitOption: true,
                };
                if (shape) {
                    nonLitEntry.shape = shape;
                }
                processedEntries.push(nonLitEntry);
            }
        }

        result[productId] = processedEntries;
    }

    return result;
};

export const fetchMaterialNrcData = async (store) => {
    try {
        const response = await fetch('/wp-content/uploads/luxxbox-acoustic-analyzer/data/data-material-nrc.json');
        if (!response.ok) {
            throw new Error('Failed to load materials data');
        }
        const materialNrcData = await response.json();
        // $log.log(`materialNrcData : ${JSON.stringify(materialNrcData, null, 4)}`);
        return materialNrcData;
    } catch (error) {
        console.error(error);
        return null;
    }
};

export const fetchSurfaceNrcData = async () => {
    try {
        const response = await fetch('/wp-content/uploads/luxxbox-acoustic-analyzer/data/data-surface-nrc.json');
        if (!response.ok) {
            throw new Error('Failed to load surface NRC data');
        }
        const surfaceNrcData = await response.json();
        return surfaceNrcData;
    } catch (error) {
        console.error(error);
        return null;
    }
};

export const fetchRoomTypeData = async (store) => {
    try {
        const response = await fetch('/wp-content/uploads/luxxbox-acoustic-analyzer/data/data-room-types.json');
        if (!response.ok) {
            throw new Error('Failed to load room data');
        }
        const roomTypeData = await response.json();
        // $log.log(`roomTypeData : ${JSON.stringify(roomTypeData, null, 4)}`);
        return roomTypeData;
    } catch (error) {
        console.error(error);
        return null;
    }
};
